export default {
  getProductList(state) {
    return state.product.list;
  },
  getProductPage: (state) => state.product.page,
  getProductLimit: (state) => state.product.limit,
  getProductPageInfo(state) {
    return state.product.pageInfo;
  },
  getStoreList(state) {
    return state.store.list;
  },
  getStorePage: (state) => state.store.page,
  getStoreLimit: (state) => state.store.limit,
  getStorePageInfo(state) {
    return state.store.pageInfo;
  },
  getFavProductList(state) {
    return state.favProductList;
  },
  getFavStoreList(state) {
    return state.favStoreList;
  }
};
